import ApplicationController from './application_controller'
import { enter } from './helpers/transitions'

export default class extends ApplicationController {
  connect () {
    enter(this.element)
  }
}
